import { Component, Prop, Vue } from 'vue-property-decorator'
import CardDeadline from '@/components/CardDeadline/index.vue'

@Component({
	components: {
		CardDeadline,
	},
})
export default class ViewYearMonth extends Vue {
	@Prop() readonly deadlinesByYearAndMonth

	today = new Date().toISOString().split('T')?.[0]
	monthNames = {
		'1': 'Janeiro',
		'2': 'Fevereiro',
		'3': 'Março',
		'4': 'Abril',
		'5': 'Maio',
		'6': 'Junho',
		'7': 'Julho',
		'8': 'Agosto',
		'9': 'Setembro',
		'10': 'Outubro',
		'11': 'Novembro',
		'12': 'Dezembro',
	}

	addZeroBefore(numberString) {
		if (numberString.length === 1) {
			return '0' + numberString
		}

		return numberString
	}
}
